/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SettlementDetailContract} from '../../../api/contracts/settlement/settlement-detail.contract';
import {SettlementDetailModel} from './settlement-detail.model';

export class SettlementDetailMapper {
    static fromSettlementDetailContractArray(input: SettlementDetailContract[]): SettlementDetailModel[] {
        return input?.map((element) => SettlementDetailMapper.fromSettlementDetailContract(element));
    }

    static fromSettlementDetailContract(input: SettlementDetailContract): SettlementDetailModel {
        let model: SettlementDetailModel;

        if (input != null) {
            model = {
                complaintCode: input.complaintCode,
                settlementCode: input.settlementCode,
                material: input.material,
                shipToParty: input.shipToParty,
                customerComplaintNumber: input.customerComplaintNumber,
                supplier: input.supplier,
                complaintDescription: input.complaintDescription,
                settlementPositions: input.settlementPositions,
                teMinutesTotalCost: input.teMinutesTotalCost,
                materialsTotalGrossCost: input.materialsTotalGrossCost,
                materialsTotalNetCost: input.materialsTotalNetCost,
                currency: input.currency,
                claimCreationDate: input.claimCreationDate,
                taxId: input.taxId
            };
        }
        return model;
    }
}
